/**
 * Typed wrapper around `posthog.capture`. The discriminated union below
 * is the source of truth for all named events fired from this client.
 * Drift is caught at build time.
 *
 * In production the call delegates to `posthog.capture`. Outside
 * production it mirrors to `console.debug` for shape verification.
 */
import { getPosthog, isPosthogEnabled } from "./posthog";
export function track(event) {
    if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.debug("[track]", event.name, event.props);
        return;
    }
    if (isPosthogEnabled() === false)
        return;
    void getPosthog()?.then((ph) => ph.capture(event.name, event.props));
}
export function registerEntrySuperProperties(props) {
    if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.debug("[register]", props);
        return;
    }
    if (isPosthogEnabled() === false)
        return;
    void getPosthog()?.then((ph) => ph.register(props));
}
